import { state as base_state } from "../../base/store/state";

export function state() {
	return Object.assign(
		{
			empty_item: null
		},
		base_state()
	);
}
